export default {
    hzzt:[
        {name:'随访期内用药中',id:'1'},
        {name:'随访期结束时未脱落',id:'2'},
        {name:'随访期结束前已脱落',id:'3'},
        {name:'未建立联系',id:'4'},
        {name:'其他',id:'5'},
    ]
}